<template>
    <zoezi-button :block="block" :text="text" :link="link" />
</template>

<script>
export default {
    name: 'zoezi-calendar-button',

    zoezi: {
        title: 'Fetch Calendar Button',
        icon: 'mdi-calendar-export'
    },

    props: {
        text: {
            title: 'Button text',
            type: String,
            default: () => window.$translate('Fetch calendar')
        },
        google: {
            title: 'Google Calendar',
            type: Boolean,
            default: false
        },
        group: {
            title: 'Group calendar',
            type: Boolean,
            default: false
        },
        globalSiteSetting: {
            title: "Show only from globally selected site",
            type: Boolean,
            default: false,
            typeinfo: {
                visible: 'group'
            }
        },
        block: {
            title: 'BLOCK',
            type: Boolean,
            default: false
        }
    },

    computed: {
        link() {
            let base = 'webcal://' + window.location.host;
            let siteIdSuffix = '';
            if (this.globalSiteSetting && this.$store.state.selectedSiteId) {
                siteIdSuffix = '?site_id=' + this.$store.state.selectedSiteId;
            }
            let suffix = this.group ? '/api/public/icalendar/get/groupworkouts' + siteIdSuffix : '/api/public/icalendar/get?id=' + this.$store.state.user?.icalendarid;
            let href = base + suffix;
            if (this.google) {
                href = 'https://www.google.com/calendar/render?cid=' + href;
            }
            return { newTab: true, href }
        }
    }
}
</script>
